import { request } from "../lib/http";

export function fetchAll() {
  return request({
    url: "temperature-sensor-delay",
    method: "get",
  });
}
